export const MAX_CUSTOM_VOD_REQUESTS_PER_DEVICE = 3;

export function formatCustomVodLimitMessage(
  activeCount: number,
  remaining: number,
  requestedCount = 1,
): string {
  if (remaining <= 0) {
    return `Maximum ${MAX_CUSTOM_VOD_REQUESTS_PER_DEVICE} queued custom VoD requests allowed while the device is offline (${activeCount} queued). Wait for uploads to finish or delete failed videos before requesting more.`;
  }

  if (requestedCount > remaining) {
    return `This request needs ${requestedCount} video slot(s), but only ${remaining} remain while the device is offline (${activeCount} of ${MAX_CUSTOM_VOD_REQUESTS_PER_DEVICE} queued).`;
  }

  return '';
}
